import axios from 'axios';

export const api = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL,
    withCredentials: true,
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            console.warn('Session expired (401)');
            // No notification, no Vuex dispatch
        }
        return Promise.reject(error);
    },
);
